/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Model from "@ember-data/model";
import type Store from "@ember-data/store";
import type ModelRegistry from "@ember-data/types/registries/model";
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type MedicModel from "parog-web/models/medic";
import type Patient from "parog-web/models/patient";

interface Signature {
  Args: {
    labelName?: unknown;
    isReadOnly?: unknown;
    changeset: EmberChangeset;
    propertyName: string;
    patient: Patient;
  };
}

interface Responsible {
  id: string;
  name: string;
}

export default class PlanificationResponsibleDropdownComponent extends Component<Signature> {
  @service declare store: Store;

  declare creator: keyof ModelRegistry | undefined;

  get changeset() {
    return this.args.changeset;
  }
  get propertyName() {
    return this.args.propertyName;
  }
  get patient() {
    return this.args.patient;
  }

  get possibleResponsibles(): Responsible[] {
    const medics = this.store.peekAll("medic");
    const responsibles = medics.map(creator => ({
      id: this._computeCustomUuid(creator),
      name: creator.fullName
    }));

    responsibles.push({
      id: this._computeCustomUuid(undefined),
      name: "Autre"
    });

    return responsibles;
  }

  get selectedResponsible() {
    const responsible = this.changeset.get(this.propertyName);
    return this._computeCustomUuid(responsible?.content || responsible);
  }

  @action
  onChange(customUuid: string) {
    this.changeset.set(
      this.propertyName,
      this._retrieveResponsible(customUuid)
    );
  }

  _computeCustomUuid(creator: MedicModel | undefined): string {
    if (creator) {
      return `${
        (creator?.constructor as typeof Model).modelName
      }-${creator?.id}`;
    }
    return "undefined-undefined";
  }

  _retrieveResponsible(customUuid: string) {
    const creatorInfos = customUuid.split("-");

    const creator = this.store.peekRecord(
      creatorInfos[0] as keyof ModelRegistry,
      creatorInfos[1]
    );
    return creator;
  }
}
